import {
  buildFdaSubmissionPdfHref,
  field,
  formatReviewTime,
  reviewTimeSources,
} from "../../helpers";
import { fda510kTheme } from "../themes";

const fda510kConfig = {
  label: "FDA 510(k)",
  theme: fda510kTheme,
  summary: {
    primary: field("Device name", ["device_name", "product_code_description"]),
    secondary: field("K number", ["k_number"], { kind: "id" }),
    columns: [
      field("Company", ["applicant"], {
        className: "hidden lg:block flex-[1.4] min-w-[10rem]",
      }),
      field("Product code", ["product_code"], {
        className: "hidden md:block flex-[0.8] min-w-[6rem]",
        kind: "accent",
      }),
      field("Decision date", ["decision_date"], {
        className: "flex-[0.95] min-w-[7rem]",
      }),
      field("Decision", ["decision_code"], {
        className: "hidden xl:block flex-[1.2] min-w-[8rem]",
        kind: "status",
      }),
    ],
  },
  detail: {
    meta: [
      field("K number", ["k_number"], { kind: "id" }),
      field("Product code", ["product_code"], { kind: "accent" }),
      field("Review time", reviewTimeSources, {
        kind: "accent",
        formatValue: formatReviewTime,
      }),
      field("Decision", ["decision_description"], { kind: "status" }),
    ],
    sections: [
      {
        title: "Applicant",
        fields: [
          field("Company", ["applicant"]),
          field("City", ["city"]),
          field("Country", ["country_code"]),
        ],
      },
      {
        title: "Device",
        fields: [
          field("Device name", ["device_name"]),
          field("Product code", ["product_code"]),
          field("Device class", ["device_class"]),
          field("Regulation number", ["regulation_number"]),
          field("Predicate 510(k) numbers", ["predicate_k_numbers"] ,
             {includeMissing: true,
              missingValue: "Not available",
               formatValue: (value) => value?.join(", ") || "Not available",
            }),
        ],
      },
      {
        title: "Review",
        fields: [
          field("Decision date", ["decision_date"]),
          field("Date received", ["date_received"]),
          field("Review time", reviewTimeSources, {
            formatValue: formatReviewTime,
          }),
          field("Decision description", ["decision_description"]),
          field("Clearance type", ["clearance_type"]),
          field("Review panel", [
            "advisory_committee_description" ,"review_advisory_committee","advisory_committee"
          ]),
          field("Third-party review", ["third_party_flag"]),
          field("Statement or summary", ["statement_or_summary"]),
        ],
      },
    ],
    links: [
      {
        label: "FDA 510(k)",
        buildHref: (record, value) =>
          value
            ? `https://www.accessdata.fda.gov/scripts/cdrh/cfdocs/cfpmn/pmn.cfm?ID=${value}`
            : "",
        sources: ["k_number"],
        valueLabel: "Open FDA record",
      },
      {
        label: "FDA 510(k) pdf",
        buildHref: (record, value) => buildFdaSubmissionPdfHref(value),
        sources: ["k_number"],
        valueLabel: "Open FDA pdf",
      },
    ],
  },
};

export default fda510kConfig;
